import { computed } from 'mobx';

export default class DataOriginModel {
  id;
  store;

  constructor(store, dataOrigin) {
    this.store = store;
    this.id = +dataOrigin.id;
    this.name = dataOrigin.name;
    this.url = dataOrigin.url;
    this.description = dataOrigin.description;
    this.address = dataOrigin.address;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      url: this.url,
      description: this.description,
      address: this.address,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.name = json.name;
    this.url = json.url;
    this.description = json.description;
    this.address = json.address;
  }
}



// WEBPACK FOOTER //
// ./src/models/Inventory/InventoryManufacturerModel.js